import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../common/api";
import { Button, Col, Descriptions, Divider, Row, Space, Table } from "antd";
import { DownloadOutlined, FileExcelOutlined, FileOutlined, PlusOutlined } from "@ant-design/icons";
import { date2locale, datetime2locale, downloadFile, formatDateTime } from "../common/common";
import Toolbar from "../common/Toolbar";
import { CSVLink } from "react-csv";

const columns = [
    {
        title: "ID",
        ellipsis: true,
        key: "id",
        dataIndex: "id",
        width: 70,
    },
    {
        title: "Nominativo",
        key: "bankAccountName",
        dataIndex: "bankAccountName",
        ellipsis: true,
        width: 250,
    },

    {
        title: "IBAN",
        key: "bankAccountIban",
        dataIndex: "bankAccountIban",
        ellipsis: true,
        width: 300,
        render: (x) => <span style={{ fontFamily: "monospace", fontSize: "0.9em" }}>{x}</span>,
    },
    {
        title: "Causale",
        key: "paymentReason",
        dataIndex: "paymentReason",
        width: 150,
        ellipsis: true,
    },
    {
        title: "Importo",
        key: "amount",
        dataIndex: "amount",
        ellipsis: true,
        align: "right",
        render: (x) => x.toLocaleString("it-IT", { minimumFractionDigits: 2, useGrouping: true }),
        width: 120,
    },
];

export default function () {
    const { id } = useParams();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [batch, setBatch] = useState({});

    useEffect(() => {
        setLoading(true);
        axiosInstance.get(`paycheckBatchBankTransfer/${id}`).then(({ data }) => setBatch(data));
        axiosInstance
            .get("bankTransfer", { params: { batch: id } })
            .then(({ data }) => setData(data))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div style={{ display: "flex", flexDirection: "column", rowGap: 16 }}>
            <Toolbar
                extra={() => (
                    <>
                        <Button
                            icon={<DownloadOutlined />}
                            type="primary"
                            onClick={() => downloadFile(`paycheckBatchBankTransfer/${id}/sepaXml`)}
                        >
                    Scarica file distinta
                            {/*<CSVLink
                                filename={`distinta_${id}.csv`}
                                data={data.map((x) => ({
                                    Nominativo: x.bankAccountName,
                                    IBAN: x.bankAccountIban,
                                    Importo: x.amount,
                                    Causale: x.paymentReason,
                                }))}
                            >
                                Scarica CSV
                            </CSVLink>*/}
                        </Button>
                    </>
                )}
            />
            <Descriptions column={3}>
                <Descriptions.Item label="Nome distinta">{batch.name}</Descriptions.Item>
                <Descriptions.Item label="Stato distinta">{batch.state}</Descriptions.Item>
                <Descriptions.Item label="Data pagamento">
                    {batch.paymentDate ? date2locale(batch.paymentDate) : ""}
                </Descriptions.Item>
                <Descriptions.Item label="Creato da" span={3}>
                    {batch.createdBy?.fullName} il {formatDateTime(batch.creationDate)}
                </Descriptions.Item>
                <Descriptions.Item label="Totale distinta">
                    {data
                        .reduce((acc, curr) => acc + curr.amount, 0)
                        .toLocaleString("it-IT", {
                            useGrouping: true,
                            minimumFractionDigits: 2,
                        })}
                </Descriptions.Item>
            </Descriptions>
            <Table
                columns={columns}
                size="small"
                style={{ marginTop: 20 }}
                tableLayout={"fixed"}
                dataSource={data.map((x) => ({ ...x, key: x.id }))}
                scroll={{ y: 300, x: columns.reduce((acc, x) => x.width + acc, 0) }}
                virtual
                rowKey="id"
                bordered
                pagination={false}
                loading={loading}
            />
        </div>
    );
}
